const tokensUrl = process.env.VUE_APP_TOKENS_URL;
const locationsUrl = process.env.VUE_APP_LOCATIONS_URL;
const sessionsUrl = process.env.VUE_APP_SESSIONS_URL;
const identityUrl = process.env.VUE_APP_IDENTITY_URL;
const commandsUrl = process.env.VUE_APP_COMMANDS_URL;
const paymentsUrl = process.env.VUE_APP_PAYMENTS_URL;
const tariffsUrl = process.env.VUE_APP_TARIFFS_URL;

export {
  tokensUrl,
  locationsUrl,
  sessionsUrl,
  identityUrl,
  commandsUrl,
  paymentsUrl,
  tariffsUrl
};
